<template>
  <AppModalEdit
    v-model="isActive"
    :is-exec-button-disabled="!editedItem.validation"
    :loading="sending"
    @clickExec="invite"
    title="アカウント招待"
    exec-button-text="招待"
  >
    <v-layout>
      <AppForm label="所属先">
        <v-layout column>
          <v-radio-group
            v-if="showRadio"
            v-model="editedItem.belongType"
            @change="clear"
            row
            style="display: inline-block;"
          >
            <v-radio
              v-if="belongType === 'system owner'"
              label="ネットワーク"
              value="systemOwner"
            />
            <v-radio label="代理店" value="agency" />
            <v-radio label="広告主" value="advertiser" />
          </v-radio-group>
          <v-select
            v-if="editedItem.belongType === 'systemOwner'"
            v-model="belongSelect"
            :loading="loading[belongList]"
            :items="belongList"
            :rules="[ruleForInvitable]"
            placeholder="所属先を選択してください"
            item-value="id"
            item-text="name"
            style="display: inline-block; min-width:320px;"
          />
          <SearchAndSelect
            v-if="editedItem.belongType === 'agency'"
            :loading="loading[belongList]"
            :searched-list="belongList"
            :selected-item="belongSelect"
            @search="searchBelongList"
            @change="selectItem"
            @clearList="clearList"
            show-list-on-init
            modal-title="代理店検索"
            button-text="代理店を検索"
          />
          <SearchAndSelect
            v-if="editedItem.belongType === 'advertiser'"
            :loading="loading[belongList]"
            :searched-list="belongList"
            :selected-item="belongSelect"
            @search="searchBelongList"
            @change="selectItem"
            @clearList="clearList"
            show-list-on-init
            modal-title="広告主検索"
            button-text="広告主を検索"
          />
          <p v-if="showRadio && canInvite" class="caution-message">
            代理店マージンなどの情報を閲覧できるユーザーは必ず代理店を選択してください。
          </p>
        </v-layout>
      </AppForm>
    </v-layout>
    <template v-if="canInvite">
      <v-slide-y-transition>
        <SelectUserType
          v-if="editedItem.belongType !== 'systemOwner'"
          v-model="editedItem.userType"
          :permission="editedItem.permission"
          :disabled="!isSelectedBelong"
          :caution="cautionMessage"
        />
      </v-slide-y-transition>
      <v-layout>
        <AppForm label="名前">
          <v-text-field v-model="editedItem.name" browser-autocomplete="off" />
        </AppForm>
      </v-layout>
      <v-layout>
        <AppForm label="メールアドレス">
          <v-text-field v-model="editedItem.email" browser-autocomplete="off" />
        </AppForm>
      </v-layout>
      <v-layout>
        <AppForm label="メールアドレス（再入力）">
          <v-text-field
            v-model="editedItem.emailConfirm"
            browser-autocomplete="off"
          />
        </AppForm>
      </v-layout>
    </template>
  </AppModalEdit>
</template>

<script>
import SelectUserType from './SelectUserType'
import { InviteAccountForm } from '@/models/Account'
import SearchAndSelect from '@/components/Shared/CrudUI/SearchAndSelect'

export default {
  name: 'ModalInvite',
  components: { SelectUserType, SearchAndSelect },
  props: {
    loading: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
    belongType: {
      type: String,
      default: '',
    },
    systemOwnerList: {
      type: Array,
      default: () => [],
    },
    agencyList: {
      type: Array,
      default: () => [],
    },
    advertiserList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editedItem: {},
      sending: false,
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    showRadio() {
      return this.belongType === 'system owner' || this.belongType === 'agency'
    },
    cautionMessage() {
      return this.editedItem.belongSelectedId
        ? '現在ログイン中のユーザーよりも小さな権限のユーザーのみ招待できます。'
        : '先に所属先を選択してください。'
    },
    belongList() {
      switch (this.editedItem.belongType) {
        case 'systemOwner':
          return this.systemOwnerList
        case 'agency':
          return this.agencyList
        case 'advertiser':
          return this.advertiserList
        default:
          return []
      }
    },
    belongSelect: {
      get() {
        switch (this.editedItem.belongType) {
          case 'systemOwner':
            return this.editedItem.systemOwnerId
              ? this.systemOwnerList.find(
                  a => a.id === this.editedItem.systemOwnerId,
                )
              : null
          case 'agency':
            return this.editedItem.agencyId
              ? this.agencyList.find(a => a.id === this.editedItem.agencyId)
              : null
          case 'advertiser':
            return this.editedItem.advertiserId
              ? this.advertiserList.find(
                  a => a.id === this.editedItem.advertiserId,
                )
              : null
          default:
            return undefined
        }
      },
      set(value) {
        this.belongList.some(belong => {
          if (belong.id === value) {
            this.editedItem.permission = belong.permission
          }
        })
        switch (this.editedItem.belongType) {
          case 'systemOwner':
            this.editedItem.systemOwnerId = value
            break
          case 'agency':
            this.editedItem.agencyId = value
            break
          case 'advertiser':
            this.editedItem.advertiserId = value
            break
        }
        return
      },
    },
    canInvite() {
      return this.editedItem.permission !== 'view'
    },
    ruleForInvitable(vm) {
      return (
        vm.canInvite || 'この所属先にアカウントを招待する権限がありません。'
      )
    },
    isSelectedBelong() {
      switch (this.editedItem.belongType) {
        case 'systemOwner':
          return this.editedItem.systemOwnerId
        case 'agency':
          return this.editedItem.agencyId
        case 'advertiser':
          return this.editedItem.advertiserId
      }
      return false
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.editedItem = new InviteAccountForm()
        this.initBelongType()
        this.searchSystemOwnerBelongList(this.editedItem.belongType)
      }
    },
  },
  methods: {
    async invite() {
      const result = await this.$confirm(undefined, {
        body: '招待メールを送信しますがよろしいですか？',
      })
      if (!result) return
      this.sending = true
      try {
        const validateEmailRegex = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (!validateEmailRegex.test(this.editedItem.email)) {
          await this.$confirm('登録エラー', {
            okText: '閉じる',
            onlyOk: true,
            body: `メールアドレスが下記の条件に当てはまる場合、アカウントの登録ができません。
              メールアドレスを修正の上、再度ご登録ください。
              
              1. ( ) < > [ ] : ; ¥ , が含まれている
              2. @が複数含まれている
              3. ダブルピリオド（..）が含まれている
              4. 先頭がハイフン（-）になっている
              5. @の後にピリオド（.）が含まれていない
              6. 先頭もしくは末尾がピリオド（.）になっている
              7. メールアドレス全体で257文字以上になっている
              8. ラベルの先頭もしくは末尾がハイフン（-）になっている
              9. スペースが含まれている
            `,
          })

          return
        }

        const res = await this.editedItem.execInvite()
        const result = await this.$confirm(undefined, {
          okText: '閉じる',
          onlyOk: true,
          body:
            '招待メールを送信しました。\n\n【メールが届かない場合】\nメールアドレスが間違っていないことをご確認ください。\n間違っていた場合は再度この画面からアカウント招待を実施してください。\nご不明な点がございましたらサポートまでご連絡ください。',
        })
        if (result) {
          this.isActive = false
          return res
        }
      } finally {
        this.sending = false
      }
    },
    initBelongType() {
      if (this.belongType === 'system owner') {
        this.editedItem.belongType = 'systemOwner'
        return
      }
      this.editedItem.belongType = this.belongType
    },
    clear() {
      this.editedItem.systemOwnerId = undefined
      this.editedItem.agencyId = undefined
      this.editedItem.advertiserId = undefined
      this.clearList()
    },
    clearList() {
      this.$store.dispatch('accountList/CLEAR_AGENCY_LIST')
      this.$store.dispatch('accountList/CLEAR_ADVERTISER_LIST')
      return
    },
    searchSystemOwnerBelongList(type) {
      if (type === 'systemOwner') {
        this.$store.dispatch('accountList/GET_SYSTEM_OWNER_LIST')
      }
    },
    searchBelongList(keyword) {
      if (keyword === '') {
        return
      }
      switch (this.editedItem.belongType) {
        case 'agency':
          this.$store.dispatch('accountList/GET_AGENCY_LIST', {
            keyword: keyword,
          })
          break
        case 'advertiser':
          this.$store.dispatch('accountList/GET_ADVERTISER_LIST', {
            keyword: keyword,
          })
          break
      }
      return
    },
    selectItem(item) {
      if (this.editedItem.belongType === 'agency') {
        this.editedItem.agencyId = item.id
      } else if (this.editedItem.belongType === 'advertiser') {
        this.editedItem.advertiserId = item.id
      }
      return
    },
  },
}
</script>

<style scoped>
.v-input {
  padding: 0;
  margin: 0;
}
.layout {
  padding-top: 16px;
}
.caution-message {
  color: red;
}
</style>
